/**
 * AskHumanBox Component
 * Displays a prompt message and button to encourage users to ask their community
 */

import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import {
  AskHumanBoxContainerInFooter,
  AskHumanPrompt,
} from './AskHumanBox.styled';
import AskHumanButton from './AskHumanButton';
import { useOcAskHumanContext } from './OcAskHumanProvider';

export interface AskHumanBoxProps {
  /**
   * Optional className for styling
   */
  className?: string;
}

/**
 * AskHumanBox Component
 * Renders a call-to-action box with prompt text and a button to open the Ask Human modal
 * Always displayed in transcript footer
 * Gets text values from OcFabWidgetOptions context
 */
const AskHumanBox: React.FC<AskHumanBoxProps> = ({
  className = '',
}) => {
  const { toggleModal } = useOcAskHumanContext();
  const { askHumanPromptText, askHumanButtonText } = useOcFabWidgetOptions();

  return (
    <AskHumanBoxContainerInFooter className={className}>
      <AskHumanPrompt>{askHumanPromptText}</AskHumanPrompt>
      <AskHumanButton
        onClick={toggleModal}
        text={askHumanButtonText}
      />
    </AskHumanBoxContainerInFooter>
  );
};

export default AskHumanBox;

